import { render, staticRenderFns } from "./BlogWrapper.vue?vue&type=template&id=30779891"
import script from "./BlogWrapper.vue?vue&type=script&lang=js"
export * from "./BlogWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports